<!-- CALENDAR SCREEN-->
<div class="header">
    <h3>Calendario</h3>
    <div class="example-spacer"></div>
    <button mat-button class="download-button" routerLink="/db/matches/calendar">
        <mat-icon>calendar_month</mat-icon>
        Ver completo
    </button>
</div>
<div class="datacolumn">
    <a *ngFor="let d of calendar" class="calendar" [routerLink]="'/db/matches/detail/'+d._id">
        <div class="match" #matchContainer [style.background]="getColor(d.competition!)">
            <img class="team" [src]="d.team?.imgUrl" [alt]="d.team?.name">
            <span class="team-name" *ngIf="d.showTeamName">{{ d.team?.name }}</span>
            <div class="example-spacer"></div>
            <div class="badges">
                <img class="league" [src]="getFoto(d.competition!)">
                <span>{{ d.date | date: 'dd/MM' }}</span>
                <mat-icon>
                    {{d.venue}}
                </mat-icon>
            </div>
        </div>
    </a>
</div>